import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

// import { ApiResponse } from '@src/backend-connector';

import { SwalService } from '@atmi/core/services/swal.service';
import { TelemetryService } from '@atmi/core/services/telemetry.service';

@Injectable()
export class ErrorsHandler implements ErrorHandler {
  constructor(
    // Because the ErrorHandler is created before the providers, we’ll have to use the Injector to get them.
    private readonly injector: Injector,
  ) {
  }

  handleError(error: Error | HttpErrorResponse) {

    const swal = this.injector.get(SwalService);
    const translate = this.injector.get(TranslateService);
    const telemetry = this.injector.get(TelemetryService);

    if (error instanceof HttpErrorResponse) {
      // Server or connection error happened
      if (!navigator.onLine) {
        // Handle offline error
        swal.showError({ title: translate.instant('Errore di conessione') }); // ERRORS.CONNECTION
      } else {
        // Handle Http Error (error.status === 403, 404...)
        const statusCode = error.status || 0;
        const title = `Errore (${statusCode})`;
        const text = this.extractServerDescription(error.error)
          || this.buildFallbackMessage(statusCode, translate);

        swal.showError({ title, text });
      }
    } else {
      // Handle Client Error (Angular Error, ReferenceError...)
      telemetry.reportError(error, 'client_error');
    }
    // Log the error anyway
    console.error('It happens: ', error);
    // Report to telemetry
    if (error instanceof HttpErrorResponse) {
      telemetry.reportError(error, `http_error_${error.status}`);
    }
  }

  private extractServerDescription(payload: unknown): string | undefined {
    const response = payload as any;

    if (!response) {
      return undefined;
    }

    if (typeof response === 'string') {
      return response;
    }

    if (Array.isArray(response?.message)) {
      return response.message.join('; ');
    }

    return response?.error?.description
      || response?.description
      || response?.error?.message
      || response?.message;
  }

  private buildFallbackMessage(statusCode: number, translate: TranslateService): string {
    switch (statusCode) {
      case 0:
        return translate.instant('Errore di connessione');
      case 401:
        return `${translate.instant('Operazione non autorizzata')} ${translate.instant('Non è possibile gestire la risorsa richiesta')}`;
      case 404:
        return translate.instant('Risorsa non trovata');
      case 500:
        return `${translate.instant('Si è verificato un\'errore inaspettato')} ${translate.instant('Contattare l\'assistenza se l\'errore persiste')}`;
      default:
        return translate.instant('Si è verificato un errore');
    }
  }

}
